var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullet3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "57.022px",
    height: "57.021px",
    viewBox: "0 0 57.022 57.021",
    enableBackground: "new 0 0 57.022 57.021",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.511,
    cy: 28.512,
    r: 28.511
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.547,44.09c-4.348,0-7.401-1.851-9.945-5.921l4.579-3.237c1.758,2.543,3.376,3.469,5.551,3.469 c2.774,0,4.347-1.758,4.347-4.395c0-3.283-2.173-4.672-5.18-4.672h-2.22v-5.596h2.266c2.684,0,4.209-1.203,4.209-3.515 c0-2.128-1.018-3.793-3.793-3.793c-1.758,0-3.006,0.74-4.671,2.405l-3.932-3.932c2.359-2.636,4.626-4.209,8.974-4.209 c5.596,0,9.25,3.469,9.25,8.834c0,3.654-1.85,5.735-4.533,6.707c2.822,0.786,5.459,3.099,5.459,7.632 C38.909,40.204,35.069,44.09,28.547,44.09z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet3);
export default __webpack_public_path__ + "static/media/Bullet3.a49e9de4a9aa566654c385747698fb51.svg";
export { ForwardRef as ReactComponent };